define('widgets/route',[
	'jquery',
	'modules/page',
	'lib/jquery-ui/widget'
], function ($, page) {

	return $.widget('muse.route', {

		options: {
			controller: null,
			url: null,
			noload: null,
		},

		_create: function () {

			this.controller = this.option('controller') || this.element.data('controller');
			this.noload = this.option('noload') || this.element.data('noload');
			this.url = this.option('url') || this.element.attr('href');

			this._on({
				'click': $.proxy(this, 'onClick')
			});

		},

		onClick: function (e) {

			if (this.noload)
				page.set(this.controller, null, this.url);
			else
				page.load(this.url, this.controller);

			e.preventDefault();

		}

	});

});
